import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import { dispatchBridgeConnectionMessage } from './connection.js';
import { dispatchBridgePreviewMessage } from './preview.js';
import { dispatchBridgeSessionMessage } from './session.js';
import { dispatchBridgeSkillsMessage } from './skills.js';
import { dispatchBridgeFileBrowserMessage } from './file-browser.js';

/**
 * Dispatch a parsed API→bridge message by `type`.
 * Callers should use {@link parseApiToBridgeMessage} so only known discriminants reach here.
 */
export function dispatchBridgeMessage(msg: ApiToBridgeMessage, deps: MessageHandlerDeps): void {
  switch (msg.type) {
    case 'auth_token':
    case 'bridge_identified':
    case 'installed_agent_auth_sync':
    case 'ha':
      dispatchBridgeConnectionMessage(msg, deps);
      break;
    case 'preview_environments_config':
    case 'preview_environment_control':
    case 'deploy_session_to_preview':
      dispatchBridgePreviewMessage(msg, deps);
      break;
    case 'agent_config':
    case 'prompt_queue_state':
    case 'prompt':
    case 'session_git_request':
    case 'rename_session_branch':
    case 'session_archived':
    case 'session_discarded':
    case 'revert_turn_snapshot':
    case 'cursor_request_response':
      dispatchBridgeSessionMessage(msg, deps);
      break;
    case 'skill_call':
    case 'skill_layout_request':
    case 'install_skills':
    case 'install_agent':
    case 'refresh_local_skills':
      dispatchBridgeSkillsMessage(msg, deps);
      break;
    case 'file_browser_request':
    case 'file_browser_search':
    case 'code_nav':
    case 'bridge_git_context_request':
    case 'list_repo_branches_request':
      dispatchBridgeFileBrowserMessage(msg, deps);
      break;
  }
}
